import { render, staticRenderFns } from "./ModalEditCp.vue?vue&type=template&id=2c14421c&scoped=true"
import script from "./ModalEditCp.vue?vue&type=script&lang=js"
export * from "./ModalEditCp.vue?vue&type=script&lang=js"
import style0 from "./ModalEditCp.vue?vue&type=style&index=0&id=2c14421c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c14421c",
  null
  
)

export default component.exports